import * as React from 'react';
import * as PropTypes from 'prop-types';
import warning from '../_util/warning';
import { changeConfirmLocale } from '../modal/locale';
export const ANT_MARK = 'internalMark';
export default class LocaleProvider extends React.Component {
    constructor(props) {
        super(props);
        changeConfirmLocale(props.locale && props.locale.Modal);
        warning(props._ANT_MARK__ === ANT_MARK, 'LocaleProvider', '`LocaleProvider` is deprecated. Please use `locale` with `ConfigProvider` instead: http://u.ant.design/locale');
    }
    getChildContext() {
        return {
            antLocale: Object.assign(Object.assign({}, this.props.locale), { exist: true }),
        };
    }
    componentDidUpdate(prevProps) {
        const { locale } = this.props;
        if (prevProps.locale !== locale) {
            changeConfirmLocale(locale && locale.Modal);
        }
    }
    componentWillUnmount() {
        changeConfirmLocale();
    }
    render() {
        return this.props.children;
    }
}
LocaleProvider.defaultProps = {
    locale: {},
};
LocaleProvider.childContextTypes = {
    antLocale: PropTypes.object,
};
